import { useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import { HNeventSetLoginRedirectUrl, HNeventSetPersonvelgerRedirectUrl } from '@helsenorge/framework-utils/web-component/events';

const useUpdateReturnUrl = (): void => {
  const location = useLocation();
  const [currentUrl, setCurrentUrl] = useState<string | null>(null);
  useEffect(() => {
    if (window.location.href !== currentUrl) {
      setCurrentUrl(window.location.href);
      HNeventSetPersonvelgerRedirectUrl(window.location.href);
      HNeventSetLoginRedirectUrl(window.location.href);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);
};
export default useUpdateReturnUrl;
